export default __webpack_public_path__ + "static/media/register-success-illustration.3ba99629.png";